import { useEffect } from 'react';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { spiceroad } from '..';

export interface getTransactionCSVProps {
  isError: Error | null;
  openCSV: () => void;
  isLoading: boolean;
  mutation: UseMutationResult<string, Error, void>;
}

export function getTransactionCSV(): getTransactionCSVProps {
  const apiUrl =
    import.meta.env['VITE_SPICEROAD_URL'] + '/v1/loans/transactions';

  const mutation = useMutation({
    mutationFn: () =>
      spiceroad
        .get('/v1/loans/transactions/token', { responseType: 'text' })
        .then((res) => res.data),
    mutationKey: ['transactionCSV'],
  });

  const openNewWindow = () =>
    window.open(`${apiUrl}/csv/jwt/${mutation.data}`, '_blank');
  const openCSV = () => (mutation.data ? openNewWindow() : mutation.mutate());
  useEffect(() => {
    mutation.data && openNewWindow();
  }, [mutation.data]);

  return {
    isError: mutation.error,
    isLoading: mutation.isPending,
    openCSV,
    mutation,
  };
}

export default getTransactionCSV;
